import { call, put, takeEvery } from 'redux-saga/effects'

function* storeData(action) {
    yield put({ type: 'SET_OTP_LOGIN_STEP_SUCCESS', data: 1 });
}
function* setOtpLoginStepSaga() {
    yield takeEvery('SET_OTP_LOGIN_STEP_REQUESTED', storeData);
}
export default setOtpLoginStepSaga;
